export default {
  API_URL: import.meta.env.VITE_API_URL || "http://localhost:5000/v1",
  CDN_URL: "https://cdn.xs2event.com",
  ENV: "development",
  SENTRY_ENABLE: false,
  SENTRY_DSN: "https://5d7944c36794b1b4af8d5604ef0659ec@sentry.xs2event.com/32",
  SENTRY_SAMPLE_RATE: 1.0,
  EVENT_MEDIA_BASE_URL: "https://cdn.xs2event.com/media-production",
  MEDIA_CONTENT_URL: "https://cdn.xs2event.com/mediacontent-local",
  FLAGS_BASE_URL: "https://cdn.xs2event.com/flags-test",
  EVENT_MEDIA_COVER_PHOTO: "cover-photo",
  VERSION: "28b9f763",
  CLICKY: 101405593,
  HOTJAR: 3055862, // NB. 3357273 in #34
  WEBAPP: "portalv2",
};
